import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../store";
import { Loader } from "../../components/loader";
import {getPetPersonalityDescription} from "../../actions/medicalRecords";
import _ from "lodash";



const $ = window.$;

const DESCRIPTION_ORDER = {
  INTRO : 'intro',
  DESCRIPTION : 'description',
  ZODIAC :  'zodiac',
  DELIVERY : 'delivery',
  OUTRO : 'outro',
}

class OpenAiPetDescriptionSuggestion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAiPersonalityDescription:'',
      personality_description_full:'',
      descriptionIntro : '', 
      descriptionArray : [], 
      descriptionZodiac : '',
      introTemp : '',
      descriptionTemp : [],
      zodiacTemp : '',
      deliveryTemp : '',
      outroTemp : '',

  
    };
  }

  changeVal = event => {
    if( event && event.target && event.target.value ){
      let value = event.target.value;
      this.setState({[event.target.name]: value });
    }
  };

  selectPersonalityDescription = () => {
    let description = this.state.openAiPersonalityDescription;
    let description_full = JSON.stringify(this.state.personality_description_full);
    let descriptionObj = {
      personality_description : description,
      personality_description_full : description_full,
    } 
    this.props.parentPetDescriptionCallback(descriptionObj);
    $("#breed_description_suggestion-modal").modal("hide");
 
   }

   retryPersonalityDescriptionGenerate = () => {
    this.setState({ loadingPetPersonalityDescription : true,});
    this.resetInfo();
    this.props.getPetPersonalityDescription(this.state.petDescriptionPrompt);
   }


   resetInfo(){
    this.setState({
      introTemp : '',
      descriptionTemp : [],
      zodiacTemp : '',
      deliveryTemp : '',
      outroTemp : '',
      openAiPersonalityDescription : '',
    });
   } 


   selectDescription = (event,type) => {
    let selectedInfo = event.target.value;
    let descriptionIntro = this.state.introTemp;
    let descriptions = this.state.descriptionTemp;
    let descriptionZodiac = this.state.zodiacTemp;
    let descriptionDelivery = this.state.deliveryTemp;
    let descriptionOutro = this.state.outroTemp;
    let descriptionText = '';
    if(type === DESCRIPTION_ORDER.INTRO){  
      if(event.target.checked === true){
        descriptionIntro = selectedInfo;
      }else{
        descriptionIntro = '';
      }
     this.setState({ introTemp: descriptionIntro });
    }else if(type === DESCRIPTION_ORDER.DESCRIPTION){
      if(event.target.checked === true){
        descriptions.push(selectedInfo);
      }else{ 
        descriptions = descriptions.filter(item => item !== selectedInfo)
      } 
      this.setState({ descriptionTemp : descriptions});

    }else if(type === DESCRIPTION_ORDER.ZODIAC){
      if(event.target.checked === true){
        descriptionZodiac = selectedInfo;
      }else{
        descriptionZodiac = ''
      }
      this.setState({zodiacTemp : descriptionZodiac });
    }else if(type === DESCRIPTION_ORDER.DELIVERY){
      if(event.target.checked === true){
        descriptionDelivery = selectedInfo;
      }else{
        descriptionDelivery = '';
      }
      this.setState({deliveryTemp : descriptionDelivery });

    }else if(type === DESCRIPTION_ORDER.OUTRO){
      if(event.target.checked === true){
        descriptionOutro = selectedInfo;
      }else{
        descriptionOutro = '';
      }
      this.setState({ outroTemp : descriptionOutro });
    }else{

    }
    if(descriptions && descriptions.length > 0){
      descriptionText = descriptions.join(" ");    
    }else{
      descriptionText ='';
    }
    let generatedDescription = `${descriptionIntro} ${descriptionText} ${descriptionZodiac} ${descriptionDelivery} ${descriptionOutro}`;
    this.setState({ openAiPersonalityDescription: generatedDescription });

   }

  componentDidMount() {  

   }
  componentWillReceiveProps = nextProps => {
    if(nextProps.petDescriptionPrompt && this.props.petDescriptionPrompt !== nextProps.petDescriptionPrompt){     
      this.setState({ loadingPetPersonalityDescription : true, petDescriptionPrompt : nextProps.petDescriptionPrompt, openAiPersonalityDescription : '' });
      $("#breed_description_suggestion-modal").modal("show");
      this.resetInfo();
      this.props.getPetPersonalityDescription(nextProps.petDescriptionPrompt);
    }

    if( nextProps.suggestedPetPersonalityDescription && this.props. suggestedPetPersonalityDescription !== nextProps.suggestedPetPersonalityDescription){      
      let descriptionInfo = nextProps.suggestedPetPersonalityDescription;
      this.setState({
        descriptionIntro : descriptionInfo.intro, 
        descriptionArray : descriptionInfo.descriptions, 
        descriptionZodiac : descriptionInfo.zodiac,
        descriptionDeliverycta : descriptionInfo.deliverycta,
        descriptionOutro : descriptionInfo.outro,
        personality_description_full : descriptionInfo,
        loadingPetPersonalityDescription : false,
      }); 
   
    }

    if( this.props.suggestedPetPersonalityDescriptionError !== nextProps.suggestedPetPersonalityDescriptionError){ 
      this.setState({ openAiPersonalityDescription : '', loadingPetPersonalityDescription : false, });    
      if(nextProps.suggestedPetPersonalityDescriptionError && nextProps.suggestedPetPersonalityDescriptionError.message && !_.isEmpty(nextProps.suggestedPetPersonalityDescriptionError.message)){  
          NotificationManager.error(nextProps.suggestedPetPersonalityDescriptionError.message);      
      }else{
        NotificationManager.error("An error occurred while loading the personality description");
      }
      $("#breed_description_suggestion-modal").modal("hide");
    }

 
  };

  render() {
    const {loadingPetPersonalityDescription, openAiPersonalityDescription, descriptionIntro, descriptionArray, descriptionZodiac, descriptionDeliverycta, descriptionOutro } = this.state;
    return (
    <div
      className="modal fade show"
      id="breed_description_suggestion-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="ConfirmationModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Puppy Personality Description
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body"> 
           { !loadingPetPersonalityDescription ?            
          <>
            <div className="row">
              <div className="form-control m-portlet m-portlet--full-height ">						
                <div className="m-portlet__body">  
                  <div className="m-section m-section--last">
                    <div className="m-section__content">				
                      <div className="m-demo">
                        <div className="m-demo__preview">
                          <div className="m-list-search">
                            <div className="m-list-search__results">														
                                    <span className="m-list-search__result-category m-list-search__result-category--first">
                                      Intro
                                    </span>
                                    <div className="m-list-search__result-item">
                                      <span className="m-list-search__result-item-icon">                                    
                                        <input type="checkbox" value={descriptionIntro}  onChange={e => this.selectDescription(e,'intro')}/>
                                      </span>
                                      <span className="m-list-search__result-item-text"> {descriptionIntro} </span>
                                    </div>											
                                    <span className="m-list-search__result-category">
                                      Description
                                    </span>
                                    { descriptionArray && descriptionArray.length > 0 && descriptionArray.map((item,index) => (
                                      <div className="m-list-search__result-item" key={index}>
                                        <span className="m-list-search__result-item-icon">													
                                           <input type="checkbox" value={item}  onChange={e => this.selectDescription(e,'description')}/>
                                        </span>
                                        <span className="m-list-search__result-item-text"> {item} </span>
                                      </div>
                                    ))                                              
                                    }
                                    <span className="m-list-search__result-category">
                                      Zodiac
                                    </span>
                                    <div className="m-list-search__result-item">
                                      <span className="m-list-search__result-item-icon">
                                          <input type="checkbox" value={descriptionZodiac}  onChange={e => this.selectDescription(e,'zodiac')}/>
                                      </span>
                                      <span className="m-list-search__result-item-text">{descriptionZodiac}</span>
                                    </div>

                                    <span className="m-list-search__result-category">
                                      Deliverycta
                                    </span>
                                    <div className="m-list-search__result-item">
                                      <span className="m-list-search__result-item-icon">
                                          <input type="checkbox" value={descriptionDeliverycta}  onChange={e => this.selectDescription(e,'delivery')}/>
                                      </span>
                                      <span className="m-list-search__result-item-text">{descriptionDeliverycta}</span>
                                    </div>
                                    <span className="m-list-search__result-category">
                                      Outro
                                    </span>
                                    <div className="m-list-search__result-item">
                                      <span className="m-list-search__result-item-icon">
                                          <input type="checkbox" value={descriptionOutro}  onChange={e => this.selectDescription(e,'outro')}/>
                                      </span>
                                      <span className="m-list-search__result-item-text">{descriptionOutro}</span>
                                    </div>                         
                                
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
            <div className="row justify-content-left mb-2">        
              <a className="btn btn-warning m-btn btn-sm m-btn--icon m-btn--pill ml-4"
                    onClick={()=> this.retryPersonalityDescriptionGenerate()}   
              >
              <span>
                <i className="fa fa-redo-alt"></i>
                <span>Retry</span>
                </span>
              </a>     
            </div>
            <div className="row">
             <span> <strong>Preview</strong></span> 
            </div>     
            <div className="row">
            <textarea
                className="form-control m-input"
                name="openAiPersonalityDescription"
                onChange={this.changeVal}
                value={openAiPersonalityDescription}
                id="exampleTextarea"
                rows="8"
              ></textarea>
            </div>
            <div className='d-flex justify-content-end'>                                
              <div>
                <span className='pet-description-word-count'>{openAiPersonalityDescription && openAiPersonalityDescription.trim().length > 0 ? openAiPersonalityDescription.trim().length: 0}/2000</span>
              </div>
            </div>             
          </>:
              <div className="row justify-content-center">
                <div className="col-2">
                      <Loader size={25} />
                </div>
              </div>
            }
          </div>
          <div className="modal-footer">
            <div>
              <button
                type="button"
                className="btn btn-secondary m-btn--pill mx-2"
                data-dismiss="modal"
              >
                Cancel
                </button>
              <button
                type="button"
                onClick={() => this.selectPersonalityDescription()}
                className="btn btn-primary m-btn--pill"
              >
                Select
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
}

const mapStateToProps = state => ({
  petShop: state.petShopReducer,
  suggestedPetPersonalityDescription : state.medicalRecordsReducer.suggestedPetPersonalityDescription,
  suggestedPetPersonalityDescriptionError : state.medicalRecordsReducer.suggestedPetPersonalityDescriptionError,
});

const mapDispatchToProps = dispatch => ({
  getPetPersonalityDescription: (data) => {
    dispatch(getPetPersonalityDescription(data));
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OpenAiPetDescriptionSuggestion)
  );